import { render, staticRenderFns } from "./XGrid.vue?vue&type=template&id=407dc345&scoped=true&"
import script from "./XGrid.vue?vue&type=script&lang=js&"
export * from "./XGrid.vue?vue&type=script&lang=js&"
import style0 from "./XGrid.vue?vue&type=style&index=0&id=407dc345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407dc345",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407dc345')) {
      api.createRecord('407dc345', component.options)
    } else {
      api.reload('407dc345', component.options)
    }
    module.hot.accept("./XGrid.vue?vue&type=template&id=407dc345&scoped=true&", function () {
      api.rerender('407dc345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/XGrid.vue"
export default component.exports